import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useChargesQuery = createQueryHook(PaymentApiClient.getShopCharges, {
  queryKey: ['charges'],
})
